import DateDuration from "./DateDuration.ts";

export default class DateInterval {

    date: Date;
    durations: Array<DateDuration>;

    /**
     * @param dateString
     * @param durations
     */
    constructor(durations: Array<DateDuration>, dateString: string = '') {
        this.durations = durations;
        this.date = '' === dateString ? new Date() : new Date(dateString);
    }

    resolveDate() {
        this.durations.forEach(dateDuration => {
            this.procesDuration(dateDuration.getDateSign(), dateDuration.getSign(), dateDuration.getInterval());
        });
    }

    /**
     * @param dateSign
     * @param sign
     * @param interval
     */
    procesDuration(dateSign: string, sign: string, interval: number) {
        switch (dateSign.toUpperCase()) {
            case 'Y':
                switch (sign) {
                    case '+':
                        this.date.setFullYear(this.date.getFullYear() + interval);
                        break;
                    case '-':
                        this.date.setFullYear(this.date.getFullYear() - interval);
                        break;
                }
                break;
            case 'M':
                switch (sign) {
                    case '+':
                        this.date.setMonth(this.date.getMonth() + interval);
                        break;
                    case '-':
                        this.date.setMonth(this.date.getMonth() - interval);
                        break;
                }
                break;
            case 'D':
                switch (sign) {
                    case '+':
                        this.date.setDate(this.date.getDate() + interval);
                        break;
                    case '-':
                        this.date.setDate(this.date.getDate() - interval);
                        break;
                }
                break;
        }
    }

    getDate() {
        this.resolveDate();

        return this.date;
    }
}





// WEBPACK FOOTER //
// ./src/Models/dateModels/DateInterval.ts